<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM16.0537 9.87793L15.5879 10.4658L12.7178 14.0889C12.1449 14.8117 11.1415 14.9653 10.4004 14.4355L10.2559 14.3203L8.50293 12.7715L7.94141 12.2744L8.93457 11.1504L9.49707 11.6475L11.249 13.1963L11.2891 13.2246C11.3277 13.2472 11.3631 13.2519 11.3926 13.249C11.4326 13.2451 11.4888 13.2243 11.542 13.1572L14.4121 9.53418L14.8779 8.94629L16.0537 9.87793Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
